module.exports = __webpack_public_path__ + "static/image/logo-family/logo_connect.png?99768e69";